import { DeleteBookingModal } from "PFApp/booking/components/delete_booking_modal/delete_booking_modal";
import { useDeleteBookingModal } from "PFApp/booking/components/delete_booking_modal/use_delete_booking_modal";
import { ActionIcon } from "PFComponents/action_icon";
import { Button } from "PFComponents/button";
import { Booking } from "PFTypes";

import { BookingSelectOption } from "../booking_questions/booking_questions.types";

type BookingDeleteButtonProps = {
  className?: string;
  kind?: "icon" | "button";
  bookingId?: number;
  profileFullName: string;
  onDeleted?: (booking: Booking, deleteOptionSelected: BookingSelectOption) => Promise<void>;
  isSingleDayBookingTemplate?: boolean;
  disabled?: boolean;
  title?: string;
};

const BookingDeleteButton = ({
  className,
  kind = "button",
  bookingId,
  profileFullName,
  onDeleted,
  isSingleDayBookingTemplate,
  disabled,
  title
}: BookingDeleteButtonProps) => {
  const modal = useDeleteBookingModal();
  const {
    state: { isOpen, data }
  } = modal;
  const isDeleteModalOpen = isOpen && !!data;

  const handleClick = () =>
    !!bookingId &&
    modal.open({
      bookingId,
      profileFullName,
      onDeleted,
      isSingleDayBookingTemplate
    });

  return (
    <>
      {kind === "icon" ? (
        <ActionIcon
          className={className}
          name="remove"
          size="sm"
          onClick={handleClick}
          disabled={disabled || !bookingId}
          title={title}
        />
      ) : (
        <Button
          className={className}
          icon="remove"
          onClick={handleClick}
          kind="secondary"
          disabled={disabled || !bookingId}
          title={title}
        />
      )}
      {isDeleteModalOpen && <DeleteBookingModal {...data} onClose={modal.close} />}
    </>
  );
};

export default BookingDeleteButton;
